import * as Dialog from "@radix-ui/react-dialog";
import { useState } from "react";

import { CancelReservationContent } from "./cancel-reservation-content";

export default function CancelReservationDialog({
  children,
  reservationId,
  isInternal = false,
  onComplete,
}: {
  children: React.ReactNode;
  reservationId: string;
  isInternal?: boolean;
  onComplete: () => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="sd-overlay">
          <Dialog.Content
            className="sd-content text-skogecha flex w-[315px] flex-col p-[30px] md:w-[690px]"
            onPointerDownOutside={(e) => e.preventDefault()}
          >
            <Dialog.Title className="mb-[50px] text-[14px] leading-none font-bold">
              予約キャンセルの確認
            </Dialog.Title>
            <CancelReservationContent
              reservationId={reservationId}
              isInternal={isInternal}
              skip={!open}
              onComplete={() => {
                setOpen(false);
                onComplete();
              }}
              onCancelClick={() => setOpen(false)}
            />
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
